import React, { useEffect } from "react";
import ForgotPassword from "../components/ForgotPassword";

function ForgotPasswordPage() {
  useEffect(() => {
    document.title = "Forgot Password";
  }, []);
  return (
    <div>
      <ForgotPassword />
    </div>
  );
}

export default ForgotPasswordPage;
